<template>
    <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/janvegas">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>            
        <v-row>
            <v-col cols="10">
                <div class="text-left">
                    <p>San Francisco to Las Vegas United UA611</p>
                </div>
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p>Ready and waiting for flight at Gate 8:25am</p>                    
                    <p>11:05AM San Francisco</p>
                    <img alt="Pillow-top beds, in-room safe, desk, blackout curtains" class="uitk-image-media" src="/vegasjan/VegasFlight.jpeg" style="width: 40%; height: auto;">     
                </div>
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p><s>12:48PM</s>12:24pm Las Vegas</p>
                </div>
            </v-col>
        </v-row>        

        <v-row>
            <v-col cols="12">
                <div class="text-left">
                    <p>January 25 Limo Las Vegas Airport to Caesars Palace</p>
                </div>
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p>Colosseum Premium Suite King</p>
                    <p>Not ready until 3:38pm</p>
                </div>
                <img alt="Pillow-top beds, in-room safe, desk, blackout curtains" class="uitk-image-media" src="https://images.trvl-media.com/lodging/1000000/50000/41300/41245/b3fcd37a.jpg?impolicy=fcrop&amp;w=1200&amp;h=800&amp;quality=medium" style="width: 40%; height: auto;">                
            </v-col>
            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p>Gordon Ramsey Burger 1:30pm to 3:35pm</p>
                    <p> Water</p>
                    <p> Cider</p>
                    <p> Pigs in a blanket</p>
                    <p> Fish and Chips</p>
                    <p> Sticky Toffee Pudding</p>
                    <p> Pub Smash (few spirits in that one)</p>
                    <p> Cost $99.66 as I did not have a room yet used my $100 celebration dinner and closed off the tab.</p>
                    <p> Another cocktail using one of my 4 drinks a day under $25</p>
                </div>
                <img alt="Pigs in a blanket" class="uitk-image-media" src="/vegasjan/PigsInBlanket.jpeg" style="width: 17%; height: auto;">                
                <img alt="Fish and chips" class="uitk-image-media" src="/vegasjan/FishAndChips.jpeg" style="width: 30%; height: auto;">                
                <img alt="Sticky Toffee Pudding" class="uitk-image-media" src="/vegasjan/StickyToffeePudding.jpeg" style="width: 17%; height: auto;">                
            </v-col>

            <v-col cols="3">
            </v-col>
            <v-col cols="9">
                <div class="text-left">
                    <p>Some gambling and drinking occurred amoung other things.</p>
                </div>               
            </v-col>            
        </v-row>  
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>